import React, { useEffect, useState, useRef } from "react";
import { Pannellum } from "pannellum-react";
import { Select } from "antd";
import "./Panoramas.css";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import { getPanoramaLocations } from "./getPanoramaLocations";
import { MdPanorama } from "react-icons/md";

function Panoramas(props) {
  const PanImage = useRef();
  const [locations, setLocations] = useState([]);
  const [location, setLocation] = useState(null);

  useEffect(() => {
    (async () => {
      const locations = await getPanoramaLocations();
      setLocations(locations);
    })();
  }, []);

  useEffect(() => {
    if (locations?.length && !location) {
      setLocation(locations[0]);
    }
  }, [locations]);

  const hotspotTooltip = (hotSpotDiv, args) => {
    const markerDiv = document.createElement("div");
    markerDiv.innerHTML = "AHP";
    markerDiv.classList.add("ahp-hotspot-marker");
    hotSpotDiv.appendChild(markerDiv);

    const infoDiv = document.createElement("div");
    infoDiv.innerHTML = "ALDEIAS HISTÓRICAS";
    infoDiv.classList.add("ahp-hotspot-info");
    hotSpotDiv.appendChild(infoDiv);

    // const hDiv2 = document.createElement("div");
    // hDiv2.innerHTML = "AHP";
    // hDiv.classList.add("ahp-hotspot2");
    // hotSpotDiv.appendChild(hDiv2);
    // console.log("E#WRWERTFG");
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <Select
          placeholder="LOCAL"
          options={locations}
          value={location?.value}
          onChange={(value) => {
            setLocation(locations?.find((l) => l.value === value));
          }}
          allowClear
          style={{ width: FIELD_WIDTHS.XXL, margin: "0 auto" }}
          bordered={false}
        />
      </div>
      <div className="ahp-panorama-grid">
        {locations?.map((l) => (
          <div className="ahp-panorama-card" onClick={() => setLocation(l)}>
            <div className="ahp-panorama-name">{l.label}</div>
            <img
              src={l?.src}
              alt="Location 1"
              style={{ display: "block", width: "100%" }}
            />
            {location?.value === l.value && (
              <div className="ahp-selected-mark">
                <MdPanorama size={30} style={{ color: "white" }} />
              </div>
            )}
          </div>
        ))}
      </div>

      <Pannellum
        ref={PanImage}
        width="100%"
        height="500px"
        image={location?.src}
        pitch={location?.pitch || 0}
        yaw={location?.yaw || 0}
        // hfov={110}
        autoLoad
        // onRender={() => {
        //   // console.log("pitch:", PanImage.current.getViewer().getPitch());
        //   // console.log("yaw", PanImage.current.getViewer().getYaw());
        // }}
        // hotspotDebug={true}
      >
        {location?.hotspots?.map((h) => (
          <Pannellum.Hotspot
            type="info"
            text={h.text}
            pitch={h.pitch}
            yaw={h.yaw}
            // tooltip={(hotSpotDiv, args) => hotspotTooltip(hotSpotDiv, args)}
            // tooltipArg={{ text: "ABC" }}
          />
        ))}
      </Pannellum>
    </div>
  );
}

export default Panoramas;
